import { render, staticRenderFns } from "./Triggers.vue?vue&type=template&id=c96059f2"
import script from "./Triggers.vue?vue&type=script&lang=js"
export * from "./Triggers.vue?vue&type=script&lang=js"
import style0 from "./Triggers.vue?vue&type=style&index=0&id=c96059f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports